"use client";

import { cn } from "@/lib/utils";
import { usePathname, useSearchParams } from "next/navigation";
import React, { HTMLAttributes, PropsWithChildren } from "react";

// Routes whose hero is a full-bleed photo the header should sit over rather than
// cut a solid bar across. /mcp/invite/[code] is deliberately not here: it keeps the
// solid bar above its promo banner.
const headerTransparentRoutes = ["/", "/home", "/mcp", "/webinar-1028"];

type Props = PropsWithChildren<{
  className?: HTMLAttributes<HTMLDivElement>["className"];
}>;

const HeaderWrapper: React.FC<Props> = ({ children, className }) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const isTransparent = headerTransparentRoutes.includes(pathname);

  const isWebviewHeader = searchParams.get("webview") === "true";

  if (isWebviewHeader) {
    return null;
  }

  return (
    <div
      className={cn(
        // No divider below `md` (mobile web, including in-app browsers like
        // Instagram's) — it read as a stray line under the compact mobile
        // header.
        "h-[75px] md:border-b md:border-foreground/10",
        isTransparent ? "bg-opacity-50 backdrop-blur-sm" : "bg-background",
        className
      )}
    >
      {children}
    </div>
  );
};

export default HeaderWrapper;
